import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "modal-wrap default-modal" }
const _hoisted_2 = {
  class: "modal fade",
  id: "shareFileModal",
  "data-backdrop": "static",
  "data-keyboard": "false",
  tabindex: "-1",
  "aria-labelledby": "shareModalLabel",
  "aria-hidden": "true"
}
const _hoisted_3 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "iconed-block-list" }, [
  /*#__PURE__*/_createVNode("ul", null, [
    /*#__PURE__*/_createVNode("li", null, [
      /*#__PURE__*/_createVNode("span", { class: "icon-wrap" }, [
        /*#__PURE__*/_createVNode("i", { class: "fa fa-folder" })
      ]),
      /*#__PURE__*/_createVNode("h5", null, "Share Folder/Files")
    ])
  ])
], -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_8 = { class: "modal-body pt-0" }
const _hoisted_9 = { class: "form-wrap" }
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = /*#__PURE__*/_createVNode("label", { for: "exampleInputEmail1" }, "Project", -1)
const _hoisted_12 = {
  key: 0,
  class: "\n                    spinner-loader-wrap\n                    d-flex\n                    align-items-center\n                    justify-content-center\n                  "
}
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = /*#__PURE__*/_createVNode("label", { for: "exampleInputEmail1" }, "Channel", -1)
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = /*#__PURE__*/_createVNode("label", { for: "exampleInputEmail1" }, "Message", -1)
const _hoisted_17 = {
  key: 0,
  class: "form-group"
}
const _hoisted_18 = /*#__PURE__*/_createVNode("label", { for: "exampleInputEmail1" }, "Files Choosed", -1)
const _hoisted_19 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorList = _resolveComponent("ErrorList")
  const _component_multiselect = _resolveComponent("multiselect")
  const _component_Button = _resolveComponent("Button")
  const _component_SuccessfulModalCustom = _resolveComponent("SuccessfulModalCustom")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode("button", {
              type: "button",
              class: "close",
              "data-dismiss": "modal",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
              "aria-label": "Close"
            }, [
              _hoisted_7
            ])
          ]),
          _createVNode("div", _hoisted_8, [
            _createVNode(_component_ErrorList, {
              errors: _ctx.state.ui.error.errorList.share,
              hasError: _ctx.state.ui.error.hasError
            }, null, 8, ["errors", "hasError"]),
            _createVNode("div", _hoisted_9, [
              _createVNode("div", _hoisted_10, [
                _hoisted_11,
                _createVNode(_component_multiselect, {
                  modelValue: _ctx.state.data.filter.projectId,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.data.filter.projectId = $event)),
                  options: _ctx.state.data.projectList,
                  "close-on-select": "true",
                  onSelect: _ctx.getChannelByProject,
                  "clear-on-select": true,
                  placeholder: "Search and select project",
                  label: "name",
                  "track-by": "name"
                }, null, 8, ["modelValue", "options", "onSelect"]),
                (!_ctx.state.data.projectList || !_ctx.state.data.projectList.length)
                  ? (_openBlock(), _createBlock("div", _hoisted_12, [
                      _createVNode("img", {
                        class: "input-loader-spinner",
                        src: _ctx.state.imageBaseUrl
                      ? `${_ctx.state.imageBaseUrl}img/loader-spinner.gif`
                      : 'img/loader-spinner.gif'
                    ,
                        alt: ""
                      }, null, 8, ["src"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode("div", _hoisted_13, [
                _hoisted_14,
                _createVNode(_component_multiselect, {
                  modelValue: _ctx.state.data.filter.channelId,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.data.filter.channelId = $event)),
                  disabled: _ctx.state.data.channelList && _ctx.state.data.channelList.length === 0,
                  options: _ctx.state.data.channelList,
                  "close-on-select": "true",
                  onSelect: _ctx.getMemberListByProjectAndChannel,
                  "clear-on-select": true,
                  placeholder: "Search and select Channel",
                  label: "name",
                  "track-by": "id"
                }, null, 8, ["modelValue", "disabled", "options", "onSelect"])
              ]),
              _createVNode("div", _hoisted_15, [
                _hoisted_16,
                _withDirectives(_createVNode("input", {
                  type: "text",
                  id: "shareMessage",
                  name: "shareMessage",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.data.shareMessage = $event))
                }, null, 512), [
                  [_vModelText, _ctx.state.data.shareMessage]
                ])
              ]),
              (_ctx.selectedFiles && _ctx.selectedFiles.length)
                ? (_openBlock(), _createBlock("div", _hoisted_17, [
                    _hoisted_18,
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.selectedFiles, (file, fileIndex) => {
                      return (_openBlock(), _createBlock("div", { key: fileIndex }, [
                        _withDirectives(_createVNode("input", {
                          type: "checkbox",
                          id: "fileCheckbox",
                          name: "fileCheckbox",
                          "onUpdate:modelValue": ($event: any) => (file.isChecked = $event)
                        }, null, 8, ["onUpdate:modelValue"]), [
                          [_vModelCheckbox, file.isChecked]
                        ]),
                        _createVNode("label", {
                          for: file.filename
                        }, _toDisplayString(file.filename), 9, ["for"])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode("div", _hoisted_19, [
            _createVNode(_component_Button, {
              buttonName: _ctx.state.data.buttonName,
              buttonLoading: _ctx.state.ui.isPostLoading.createCommunication,
              onButtonTrigger: _ctx.createCommunication
            }, null, 8, ["buttonName", "buttonLoading", "onButtonTrigger"]),
            _createVNode("button", {
              type: "button",
              class: "btn secondary-btn",
              "data-dismiss": "modal",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
            }, " Close ")
          ]),
          (_ctx.state.data.showSuccesCustomModal)
            ? (_openBlock(), _createBlock(_component_SuccessfulModalCustom, {
                key: 0,
                onClose: _ctx.closeSuccessCustomModal,
                showModal: _ctx.state.data.showSuccesCustomModal,
                titleMessage: _ctx.state.data.successFulMessage
              }, null, 8, ["onClose", "showModal", "titleMessage"]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}